module.exports = __webpack_public_path__ + "img/0005.f35166bc.jpg";